import { BaseQBankOverviewList, type QBankOverviewListItem } from '../../components';
import { useItemAnalysisSearchParams } from '../../hooks';
import { useItemAnalysis } from '../../providers';

export default function QBankOverviewList() {
  const { isFilterSet, searchItemAnalysisLoading, questionAnalysisData } = useItemAnalysis();
  const [{ page, pageSize }, { changePage, changePageSize }] = useItemAnalysisSearchParams();
  const rows: QBankOverviewListItem[] =
    questionAnalysisData?.records.map((record, index) => ({
      id: record.questionId,
      order: index + 1 + page * pageSize,
      code: record.questionRefCode,
      firstPublishedAt: record.firstPublishedAt,
      lastPublishedAt: record.lastPublishedAt,
      type: record.calculated,
      status: record.status,
      pInitial: record.pInitial.toFixed(2),
      pUse: record.pUse.toFixed(2),
      bIndexInitial: record.bIndexInitial?.toFixed(2) ?? null,
      answer: record.answer,
    })) ?? [];
  const total = questionAnalysisData?.total ?? 0;

  return (
    <BaseQBankOverviewList
      isSearching={isFilterSet}
      loading={searchItemAnalysisLoading}
      rows={rows}
      slotProps={{
        footer: {
          total: total,
          pagination: {
            page: page,
            count: total,
            rowsPerPage: pageSize,
            onPageChange: (_event, page) => {
              changePage(page);
            },
            onRowsPerPageChange: (event) => {
              const pageSize = Number.parseInt(event.target.value, 10);
              changePageSize(pageSize);
            },
          },
        },
      }}
    />
  );
}
